import styled from "styled-components";
import { spacing } from "../../../design-system/tokens/spacing";

/**
 * Filmstrip: a plain row of SlideThumbnail cards, shrink-to-content, with the
 * chevrons shown only on overflow. No container chrome (design F16).
 */
export const StripRoot = styled.div`
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  gap: ${spacing[3]};
  max-width: 100%;
`;

/** Horizontally scrollable row of thumbnails; scrollbar hidden (chevrons navigate). */
export const Track = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing[3]};
  min-width: 0;
  overflow-x: auto;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
`;

/** Vertical rail: a plain column, no chevrons, no inner scroll. */
export const VerticalRoot = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: ${spacing[1]};
  min-width: 0;
`;
